<template>
  <div class="main-content">
    <!-- CARDS -->
    <div class="container-fluid">
      <!-- / .row -->
      <div class="row">
        <div class="col-12">
          <!-- Convertions -->
          <b-overlay :show="overlay" rounded="lg" >
            <div class="card mt-5">
              <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Presence Data</h4>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-end mb-3">
                  <label class="align-self-center mb-0 mr-3">Search</label>
                  <b-form-input v-model="searchTerm" class="w-auto" placeholder="Type Here..."></b-form-input>
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="list"
                  :line-numbers="true"
                  :search-options="{
                    enabled: true,
                    externalQuery: searchTerm,
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: pageLength,
                  }">
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'man_hours'">
                      {{ formatNumber(props.row.man_hours) }}
                    </span>
                    <div
                      v-else-if="props.column.field == 'action'"
                      class="text-center"
                    >
                      <button class="btn btn-sm btn-info me-2" title="Detail" v-b-modal.modal-detail @click="detail(props.row)">
                        <span class="fe fe-eye"></span>
                      </button>
                    </div>
                  </template>
                  <template slot="pagination-bottom" slot-scope="props">
                    <div class="d-flex justify-content-end">
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="props.total"
                          :per-page="pageLength"
                          first-number
                          last-number
                          align="right"
                          prev-class="prev-item"
                          next-class="next-item"
                          class="m-3"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        >
                        </b-pagination>
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
      <!-- / .row -->
      <!-- MODALS -->
      <b-modal id="modal-detail" size="xl" hide-footer title="Detail User Presence" centered scrollable>
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-12 border-right">
            <table cellpadding="2">
              <tr><td>NIK</td><td>:</td><td>{{details.nik}}</td></tr>
              <tr><td>Name</td><td>:</td><td>{{details.fullname}}</td></tr>
              <tr><td>Position</td><td>:</td><td>{{details.position_name}}</td></tr>
              <tr><td>Department</td><td>:</td><td>{{details.department_name}}</td></tr>
              <tr><td>Company</td><td>:</td><td>{{details.company_name}}</td></tr>
            </table>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-12">
            <h2 class="mb-2">Detail Presence</h2>
            <div class="accordion" role="tablist" v-for="(s, i) in details.session_detail" :key="i">
              <div>
                <table class="table myTable mb-0" cellpadding="2">
                  <tr><th>Work From</th><th>Check In</th><th>Check Out</th><th>Man Hour(s)</th></tr>
                  <tr><td>{{s.work_from}}</td><td>{{formatDate(s.check_in)}}</td><td>{{formatDate(s.check_out)}}</td><td>{{formatNumber(s.man_hours)}}</td></tr>
                  <tr><td colspan="4"><b-link href="#" v-b-toggle="`collapse-${i}`" class="p-0">Show Details</b-link></td></tr>
                </table>
              </div>
              <b-collapse :id="`collapse-${i}`" class="my-2 ml-4" accordion="session_detail">
                <table class="table myTable mb-0" cellpadding="2">
                  <tr><th>Location</th><th>Type</th><th>Time</th></tr>
                  <tr v-for="(p, idx) in s.presence_detail" :key="idx"><td>{{p.location_name}}</td><td>{{p.access_type}}</td><td>{{formatDate(p.access_time)}}</td></tr>
                </table>
              </b-collapse>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
  <!-- / .main-content -->
</template>
<style>
  .myTable th, .myTable td {
    border: 1px solid black !important;
  }
</style>
<script>
import "../../assets/js/theme.bundle";
import "../../assets/js/vendor.bundle";
import moment from "moment";

export default {
  name: "presenceList",
  computed: {
    columns() {
      return this.$store.getters["presence_detail/columns"];
    },
    list() {
      return this.$store.getters["presence_detail/list"];
    },
  },
  data() {
    return {
      searchTerm: "",
      pageLength: 10,
      params: {},
      overlay: true,
      details: {}
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$store.dispatch("presence_detail/GET_LIST").finally(() => this.overlay = false)
    },
    formatNumber(n) {
      return n.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("D MMM YY HH:mm:ss");
      }
      return date;
    },
    detail(row) {
      console.log('data', row);
      this.details = row
    },
  },
};
</script>